import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { BRAND, CONTACT, NAV } from "../data/content";
import { Leaf } from "./Decor";

export const Footer = () => {
  return (
    <footer className="relative mt-24 bg-[#84A98C] text-white overflow-hidden" data-testid="footer">
      <div aria-hidden className="pointer-events-none absolute -top-8 -left-8 opacity-20">
        <Leaf color="#ffffff" size={140} />
      </div>
      <div aria-hidden className="pointer-events-none absolute bottom-6 right-8 opacity-20 rotate-45">
        <Leaf color="#ffffff" size={110} />
      </div>

      <div className="relative mx-auto max-w-7xl px-5 md:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3">
            <img src={BRAND.logo} alt="logo" className="h-14 w-14 rounded-full object-cover ring-2 ring-white/60" />
            <div className="font-head font-700 text-xl">Divinities Cove</div>
          </div>
          <p className="mt-4 font-hand text-2xl text-[#FFD166]">{BRAND.tagline}</p>
          <p className="mt-2 text-sm text-white/85 font-body">{BRAND.rooted}</p>
        </div>

        <div>
          <h4 className="font-head font-600 text-lg mb-4">Explore</h4>
          <ul className="space-y-2 font-body text-sm">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-white/85 hover:text-white transition-colors" data-testid={`footer-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}>
                  {n.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/enroll" className="text-white/85 hover:text-white transition-colors" data-testid="footer-link-enroll">Enroll / Contact</Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-head font-600 text-lg mb-4 flex items-center gap-2"><Clock size={18} /> Hours</h4>
          <ul className="space-y-2 font-body text-sm">
            {CONTACT.hours.map((h) => (
              <li key={h.day} className="flex flex-col">
                <span className="text-white/95 font-600">{h.day}</span>
                <span className="text-white/80">{h.time}</span>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-head font-600 text-lg mb-4">Get in Touch</h4>
          <ul className="space-y-3 font-body text-sm">
            <li className="flex items-start gap-3"><Phone size={18} className="mt-0.5 shrink-0" /><span>{CONTACT.phone}</span></li>
            {CONTACT.email && <li className="flex items-start gap-3"><Mail size={18} className="mt-0.5 shrink-0" /><span>{CONTACT.email}</span></li>}
            {CONTACT.address && <li className="flex items-start gap-3"><MapPin size={18} className="mt-0.5 shrink-0" /><span>{CONTACT.address}</span></li>}
          </ul>
          <div className="mt-5 inline-flex items-center gap-2 bg-white/15 rounded-full px-4 py-2 text-sm font-600">
            🌿 Organic · Meat-Free Kitchen
          </div>
        </div>
      </div>

      <div className="relative border-t border-white/20">
        <div className="mx-auto max-w-7xl px-5 md:px-8 py-5 text-center text-sm text-white/75 font-body">
          © {new Date().getFullYear()} {BRAND.name}. Rooted in Love, Learning, Community & Indigenous Wisdom.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
